import request from '@/utils/request'


//修改头像
export function setAvartr(data) {
  return request({
    url: '/app/course/uploadHead',
    method: 'post',
    data
  })
}

  //检测新版本

  export function getEdition(data) {
    return request({
      url: '/app/course/selectVersionApp',
      method: 'post',
      data
    })
  }